<template>
  <header class="container header add-padding">
    <div class="logo">
      <img src="title.png">
    </div>

    <nav>
      <ul id="menu-main-menu" class="menu">
        <li v-for="pg in pages" v-bind:key="pg.id">
          <a @click="menu(pg.id)">{{pg.nom}}</a>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>

export default {
  props: {
    pages: Array
  },

  methods: {
    menu(p) {
      this.$emit('clicked', p)
    }
  }
}

</script>

<style scoped>

.header {
  position: relative;
  padding-top: 10px;
  padding-bottom: 0px;
  text-align: center;
}

.header .logo {
  display: block;
  margin: 30px auto;
}

.header .logo img {
  height: 150px;
  text-align: center;
  vertical-align: middle;
}

@media screen and (max-width: 1024px)
{
  .header .logo img {
    height: 120px;
  }
}

@media screen and (max-width: 750px)
{
  .header {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .header .logo img {
    height: 60px;
  }

  .header nav a {
    display: none;
    padding: 0px 10px;
  }
}

.header nav {
  border-top: 1px solid #d8d8d8;
  display: flex;
  justify-content: center;
  align-items: center;
}

.header ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
}

.header nav a {
  font-size: 0.9rem;
  padding: 30px 25px 20px;
}

a {
  transition: color 200ms ease, opacity 200ms ease;
  outline: none !important;
  background: 0 0;
  cursor: pointer;
}

nav a {
  display: block;
  text-transform: uppercase;
  text-decoration: none;
  outline: none !important;
  color: #707070;
}

nav a:hover {
  color: #000;
}

main, nav {
  display: block;
}

</style>
